import { Contact } from "@/lib/vibrato-api"
import React, { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { CallTable } from "./calls/CallHistory"
import { VibratoClientContext } from "./contexts"

export default function CampaignCalls(): React.JSX.Element {
  const navigate = useNavigate()
  const { uuid } = useParams()
  const vibratoClient = useContext(VibratoClientContext)

  const [contacts, setContacts] = useState<Contact[]>([])
  const [selectedContactUuid, setSelectedContactUuid] = useState<string | null>(null)

  useEffect(() => {
    if (!uuid) {
      navigate("/campaigns")
    } else {
      fetchContacts()
    }
  }, [uuid, navigate])

  const fetchContacts = async () => {
    let allContacts: Array<Contact> = []
    let pageLink: string | null = null

    do {
      const response: any = await vibratoClient.getContacts({ campaignUuid: uuid, pageLink: pageLink })
      allContacts = [...allContacts, ...response.results]
      pageLink = response.next
    } while (pageLink)

    setContacts(allContacts)
  }

  return (
    <div className="py-8 pr-8 h-full w-full flex flex-col gap-4">
      <div className="flex justify-between place-items-center mb-4">
        <h2 className="text-xl font-bold">Calls</h2>
        <div className="flex place-items-center gap-4">
          <select
            id="contactFilter"
            className="border border-gray-300 rounded"
            value={selectedContactUuid ?? ""}
            onChange={(e) => setSelectedContactUuid(e.target.value)}
          >
            <option value="">All Contacts</option>
            {contacts.map((contact) => (
              <option key={contact.uuid} value={contact.uuid}>
                {contact.display_name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {selectedContactUuid ? (
        <CallTable campaignUuid={uuid} contactUuid={selectedContactUuid} />
      ) : (
        <CallTable campaignUuid={uuid} />
      )}
    </div>
  )
}
